import $ from "jquery"
import { trace } from "rytm-helpers"

/**
* Controller prototype
**/
class Controller {

  /**
  * Controller class constructor  
  * @constructor
  * @param {Int|String} id - unique controller id  
  **/
  constructor(id) {
    this.id = id;
    this.name = false;
    this.active = false;
    this.view = false;
    trace("controller created", id, this);
  }
  /**
  * set the View object
  * @param {View} viwe
  **/
  setView(view) {
    this.view = view;
  }
  /**
  * get the controller status
  * @returns {Boolean} 
  **/
  isActive() {
    return this.active;
  }
  /**
  * find my $view container in wrapper
  * @param {jQuery} $wrapper - search within this element
  * @retunrs {jQuery|Boolean} $view | false
  **/
  getViewContainer($wrapper) {    
    return $wrapper.find('*[data-as-id="' + this.id + '"]');
  }

  getContainerSelector() {
   return '[data-as-id="' + this.id + '"]';
  }
  

  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    // trace("add event listeners", this.id);
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    // trace("remove event listeners", this.id);
  }


  /**
  * on URL request
  * @param {Event} e
  **/
  onRequestUrl(e) {
  }
  /**
  * on url request load start
  * @param {Event} e
  **/
  onRequestLoad(e) {
  }
  /**
  * on url request loaded - PREPARE
  * @param {Event} e
  **/
  onRequestLoaded(e) {
    // trace("###### on request loaded", this.id, this.active, this.view);
    if (!this.active && this.view) {      
      this.view.prepare(e.target.$freshContent);
    }
  }
  /**
  * on view hide - animation out / hide start
  * request is loaded and fresh content is ready to init 
  * loaded content available <code>e.target.$freshContent</code>
  * @param {Event} e
  **/  
  onViewHide(e) {
    this.removeEventListeners();
    if (this.view) {
      this.view.hide();
    }
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      container.classList.add("as-hide")
    }
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    this.active = false;
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      container.classList.remove("as-hide")
    }
  }

  /**
  * on view Swap start - just before content gets replaced
  * @param {Event} e
  **/
  onViewSwapStart(e) {
    
  }
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
  }
  
  /**
  * on view show - animation in / show start
  * @param {Event} e
  **/
  onViewShow(e) { 
    if (!this.active && this.view) {
      this.view.show();
      // trace("show view fire", this.acive, this.view);
    } else {
      // trace("show view didn't fire", this.acive, this.view);
    }
    const container = document.querySelector(this.getContainerSelector())
    container.classList.add("as-show")

  }
  /**
  * on view shown - animation in / show complete
  * @param {Event} e
  **/
  onViewShown(e) {
    if (this.active) {
      return;
    }
    this.addEventListeners();
    this.active = true;
    const container = document.querySelector(this.getContainerSelector())
    container.classList.remove("as-show")
  }

  

  /**
  * #################################
  * ########### HELPERS #############
  **/


}

export default Controller;